module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/ceremony-plan-2-og-image-6e6751064d9442b6a60ecead9a2b7037.png";